
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../Sidebar";
import { ToastContainer } from "react-toastify";
import { SERVER_PATH } from "../../config/env";
import { errorToaster, successToaster } from "../../utils";
import TooltipMessage from "../Tooltip";
import { Breadcrumbs } from "../Breadcrumb";
import apiClient from "../../utils/api";

export default function NewProduct() {
  const [message, setMessage] = useState({
    msg1: true,
    msg2: true,
    msg3: true,
    msg4: true,
  });

  // let initForm = {
  //   product_name: "",
  //   description: "",
  //   instructions: "",
  //   ingredients: "",
  //   keywords: "",
  //   price: "",
  //   offer: "",
  //   offer_price: "",
  //   category: "",
  //   statusValue: "1",
  //   weight: "",
  // };
  let initForm = {
    product_name: "",
    description: "",
    price: "",
    offer: "",
    offer_price: "",
    category: "",
    statusValue: "1",
    weight: "",
  };


  let imgForm = {
    img1: "",
    img2: "",
    img3: "",
    img4: "",
  };

  const url = `post/product.php`;

  const [data, setData] = useState(initForm);
  const [imgData, setImgData] = useState(imgForm);

  const dataHandler = async (e) => {
    const arr = { ...data };
    arr[e.target.name] = e.target.value;
    setData(arr);
  };
  const statusHandler = (e) => {
    setData((prev) => ({ ...prev, statusValue: e.target.value }));
  };

  const mainImgHandler = async (e, key) => {
    let imgArr = { ...imgData };
    if (e.target?.files?.length) {
      let fileSize = Math.round(e.target.files[0].size / 1024);
      if (fileSize > 0) {
        if (fileSize <= 5 * 10) {
          const base64 = await convertToBase64(e.target.files[0]);
          imgArr[e.target.name] = base64;
          setMessage({ ...message, msg1: false });
        } else {
          setMessage({ ...message, msg1: true });
        }
      }
    } else {
      imgArr[e.target.name] = e.target.value;
    }
    setImgData(imgArr);
  };

  const subImgHandlerOne = async (e, key) => {
    let imgArr = { ...imgData };
    if (e.target?.files?.length) {
      let fileSize = Math.round(e.target.files[0].size / 1024);
      if (fileSize > 0) {
        if (fileSize <= 5 * 10) {
          const base64 = await convertToBase64(e.target.files[0]);
          imgArr[e.target.name] = base64;
          setMessage({ ...message, msg2: false });
        } else {
          setMessage({ ...message, msg2: true });
        }
      }
    } else {
      imgArr[e.target.name] = e.target.value;
    }
    setImgData(imgArr);
  };

  const subImgHandlerTwo = async (e, key) => {
    let imgArr = { ...imgData };
    if (e.target?.files?.length) {
      let fileSize = Math.round(e.target.files[0].size / 1024);
      if (fileSize > 0) {
        if (fileSize <= 5 * 10) {
          const base64 = await convertToBase64(e.target.files[0]);
          imgArr[e.target.name] = base64;
          setMessage({ ...message, msg3: false });
        } else {
          setMessage({ ...message, msg3: true });
        }
      }
    } else {
      imgArr[e.target.name] = e.target.value;
    }
    setImgData(imgArr);
  };

  const subImgHandlerThree = async (e, key) => {
    let imgArr = { ...imgData };
    if (e.target?.files?.length) {
      let fileSize = Math.round(e.target.files[0].size / 1024);
      if (fileSize > 0) {
        if (fileSize <= 5 * 10) {
          const base64 = await convertToBase64(e.target.files[0]);
          imgArr[e.target.name] = base64;
          setMessage({ ...message, msg4: false });
        } else {
          setMessage({ ...message, msg4: true });
        }
      }
    } else {
      imgArr[e.target.name] = e.target.value;
    }
    setImgData(imgArr);
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const dataSubmit = async (e) => {
    e.preventDefault();
    let info = { ...data, ...imgData };
    apiClient
      .post(url, {
        ...info,
        status: info.statusValue,
      })
      .then(() => {
        setData(initForm);
        successToaster({ msg: "Product added successfully" });
      })
      .catch(() => {
        errorToaster({ msg: "Something went wrong" });
      });
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }}>
            <Row className="p-4">
              <Col className="addProduct rounded shadow p-3">
                <Breadcrumbs currentPathName="New Prdouct" />
                <form onSubmit={dataSubmit}>
                  <div>
                    <div className="newProductHeadingStyle text-uppercase">
                      <h1>Add New Product</h1>
                    </div>
                    <Row>
                      <Col lg={6} className="addProductDiv">
                        <div className="addProductField">
                          <span>name</span>
                          <input
                            placeholder="Product Name"
                            autoComplete="off"
                            required
                            type="text"
                            name="product_name"
                            value={data.product_name.replace(
                              /[^a-zA-Z0-9 ]/gi,
                              ""
                            )}
                            onChange={(e) => dataHandler(e)}
                          />
                        </div>
                        <div className="addProductField">
                          <span>price</span>
                          <input
                            placeholder="Product Price"
                            autoComplete="off"
                            required
                            type="number"
                            name="price"
                            value={data.price > 0 && data.price}
                            onChange={(e) => {
                              dataHandler(e);
                            }}
                          />
                        </div>
                        <div className="addProductField">
                          <span>description</span>
                          <textarea
                            placeholder="Product Description"
                            autoComplete="off"
                            required
                            cols="30"
                            rows="1"
                            name="description"
                            value={data.description.replace(/[^a-zA-Z ]/gi, "")}
                            onChange={(e) => dataHandler(e)}
                          ></textarea>
                        </div>
                        <div className="addProductField">
                          <span>weight</span>
                          <input
                            placeholder="Product Weight in kg."
                            autoComplete="off"
                            required
                            type="number"
                            name="weight"
                            value={data.weight > 0 && data.weight}
                            onChange={(e) => dataHandler(e)}
                          />
                        </div>
                        {/* <div className="addProductField">
                          <span>instructions</span>
                          <input
                            placeholder="Product Instructions"
                            autoComplete="off"
                            required
                            type="text"
                            name="instructions"
                            value={data.instructions.replace(
                              /[^a-zA-Z ]/gi,
                              ""
                            )}
                            onChange={(e) => dataHandler(e)}
                          />
                        </div> */}
                        {/* <div className="addProductField">
                          <span>ingrediants</span>
                          <input
                            placeholder="Product Ingredients"
                            type="text"
                            name="ingredients"
                            value={data.ingredients.replace(/[^a-zA-Z ]/gi, "")}
                            onChange={(e) => dataHandler(e)}
                          />
                        </div> */}
                        {/* <div className="addProductField">
                          <span>keywords</span>
                          <input
                            placeholder="Product Keywords"
                            autoComplete="off"
                            required
                            type="text"
                            name="keywords"
                            value={data.keywords}
                            onChange={(e) => dataHandler(e)}
                          />
                        </div> */}
                        <div className="addProductField">
                          <span>offer(%)</span>
                          <input
                            placeholder="Enter Offer Percentage"
                            autoComplete="off"
                            required
                            type="number"
                            name="offer"
                            value={data.offer > 0 && data.offer}
                            onChange={(e) => dataHandler(e)}
                          />
                        </div>
                        <div className="addProductField">
                          <span>offer price</span>
                          <input
                            readOnly
                            style={{ cursor: "not-allowed" }}
                            required
                            placeholder="Offer Price"
                            autoComplete="off"
                            type="number"
                            name="offer_price"
                            value={parseInt(
                              (data.offer_price =
                                data.price - (data.price * data.offer) / 100)
                            )}
                            onChange={(e) => {
                              setData({
                                ...data,
                                offer_price: parseInt(
                                  (data.offer_price =
                                    data.price -
                                    (data.price * data.offer) / 100)
                                ),
                              });
                              dataHandler(e);
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className="addProductDiv">
                        <div className="addProductField">
                          <span>category</span>
                          <select
                            autoComplete="off"
                            required
                            name="category"
                            value={data.category}
                            onChange={(e) => dataHandler(e)}
                          >
                            <option value="select">Select Category</option>
                            <option value="iron">iron</option>
                            <option value="brass">brass</option>
                            <option value="wooden">wooden</option>
                            <option value="soap">soap</option>
                            <option value="combo">combo</option>
                            <option value="bakery">bakery</option>
                            <option value="unique">unique</option>
                            <option value="others">others</option>
                          </select>
                        </div>
                        <div className="addProductField">
                          <span>status</span>
                          <select
                            name="statusValue"
                            value={data.statusValue}
                            onChange={statusHandler}
                          >
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>
                        <div className="addProductField">
                          <span>
                            main image
                            <small>
                              <TooltipMessage />
                            </small>
                          </span>
                          <input
                            autoComplete="off"
                            required
                            type="file"
                            name="img1"
                            onChange={(e) => {
                              mainImgHandler(e, "msg1");
                            }}
                          />
                          {message.msg1 && (
                            <span className="ms-1 mt-1 text-danger text-capitalize">
                              upload file size less then 50KB
                            </span>
                          )}
                        </div>
                        <div className="addProductField">
                          <span>
                            sub image one
                            <small>
                              <TooltipMessage />
                            </small>
                          </span>
                          <input
                            autoComplete="off"
                            required
                            type="file"
                            name="img2"
                            onChange={(e) => {
                              subImgHandlerOne(e, "msg2");
                            }}
                          />
                          {message.msg2 ? (
                            <span className="ms-1 mt-1 text-danger text-capitalize">
                              upload file size less then 50KB
                            </span>
                          ) : null}
                        </div>
                        <div className="addProductField">
                          <span>
                            sub image two
                            <small>
                              <TooltipMessage />
                            </small>
                          </span>
                          <input
                            autoComplete="off"
                            required
                            type="file"
                            name="img3"
                            onChange={(e) => subImgHandlerTwo(e, "msg3")}
                          />
                          {message.msg3 ? (
                            <span className="ms-1 mt-1 text-danger text-capitalize">
                              upload file size less then 50KB
                            </span>
                          ) : null}
                        </div>
                        <div className="addProductField">
                          <span>
                            sub image three
                            <small>
                              <TooltipMessage />
                            </small>
                          </span>
                          <input
                            autoComplete="off"
                            required
                            type="file"
                            name="img4"
                            onChange={(e) => {
                              subImgHandlerThree(e, "msg4");
                            }}
                          />
                          {message.msg4 ? (
                            <span className="ms-1 mt-1 text-danger text-capitalize">
                              upload file size less then 50KB
                            </span>
                          ) : null}
                        </div>

                        <div className="addProductField">
                          <button className="btn btn-success">
                            add product
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
}
